import React from "react";
import { Warning, Clock } from "@phosphor-icons/react";

/**
 * Detect the "between seasons" state from an FPL context object.
 * True when the previous season is over and the new one hasn't started
 * yet (fixtures list empty, no team has played any game in the current bootstrap).
 */
export function isBetweenSeasons(context) {
    if (!context) return false;
    const info = context.season_info || {};
    if ((info.remaining_gameweeks ?? -1) !== 0) return false;
    if ((info.max_played ?? 0) > 0) return false;
    return (context.upcoming_fixtures?.length ?? 0) === 0;
}

/**
 * Banner shown on pages that depend on live-season data (race tables,
 * transfer signals) whenever we detect the "between seasons" window.
 */
export function SeasonEndBanner({ context, className = "" }) {
    if (!isBetweenSeasons(context)) return null;
    const info = context?.season_info || {};
    return (
        <div
            className={`border border-orange-400/40 bg-orange-500/[0.06] p-4 flex items-start gap-3 ${className}`}
            data-testid="season-end-banner"
        >
            <Warning size={22} weight="fill" className="text-orange-300 shrink-0 mt-0.5" />
            <div className="space-y-1">
                <h3 className="font-display font-black text-sm uppercase tracking-widest text-orange-200">
                    Mezi sezónami · živá data offline
                </h3>
                <p className="font-mono text-[11px] text-white/70 leading-relaxed">
                    Sezóna 2025-26 skončila (GW{info.current_gameweek || 38} · END) a rozpis nové sezóny 2026-27
                    zatím FPL API nezveřejnilo. Race o titul, transfery a další sekce založené na aktuální
                    tabulce zůstávají prázdné, dokud se nová sezóna nespustí. Do té doby jdi na
                    <a href="/tools/season-dna" className="text-fa-yellow hover:underline ml-1">FPL Timing Analyzer</a> —
                    tam už používáme SportMonks fixtures pro predikce 2026-27.
                </p>
                <div className="flex items-center gap-2 pt-1 font-mono text-[9px] uppercase tracking-widest text-white/45">
                    <Clock size={10} weight="fill" />
                    Startovní deadline se očekává v srpnu 2026
                </div>
            </div>
        </div>
    );
}
